import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';
import { selectAndSortSuspendedDashoardUsers } from '@/store/selectors';
import { getSuspendedSupportUsers } from '@/features/dashboard-users/store/support-user.actions';

export function useSuspendedDashboardUsers() {
  const dispatch = useAppDispatch();
  const suspendedDashboardUsers = useAppSelector(selectAndSortSuspendedDashoardUsers);

  const suspendedDashboardUsersCursor = useAppSelector((state) => state.supportUser.suspendedDashboardUsers?.cursor);
  const isSuspendedDashboardUsersLoading = useAppSelector(
    (state) => state.supportUser.searchSuspendedDashboardUsers?.isLoading,
  );

  useEffect(() => {
    dispatch(getSuspendedSupportUsers());
  }, [dispatch]);

  const handleNavigationSuspendedDashboardUsers = useCallback(
    (cursorId: string) => {
      dispatch(getSuspendedSupportUsers({ cursor: cursorId }));
    },
    [dispatch],
  );

  return {
    suspendedDashboardUsers,
    suspendedDashboardUsersCursor,
    isSuspendedDashboardUsersLoading,
    handleNavigationSuspendedDashboardUsers,
  };
}
